import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextMedium,
  Button,
} from '../../components';
import EndMessage from './EndMessage';

const Step4EndMessage = (props) => {
  const {
    dimensions,
    configOptions,
    setCurrentStep,
  } = props;

  return (
    <FormColumn>
      <EndMessage
        dimensions={dimensions}
        configOptions={configOptions}
      />
      <FormRow justifyContent='center'>
        <FormColumn width={200}>
          <Button
            textColor={configOptions.buttonTextColor}
            background={configOptions.buttonBackgroundColor}
            text={getDic("face-collector-step-4-a")}
            onPress={() => setCurrentStep(1)}
          />
        </FormColumn>
      </FormRow>
    </FormColumn>
  )
};

export default Step4EndMessage;
